<template lang="pug">
  v-menu(
      v-model="menu",
      :close-on-content-click="false",
      :nudge-right="40",
      transition="scale-transition",
      offset-y,
      min-width="290px"
    )
    template(v-slot:activator="{ on }")
      v-text-field(
        v-model="time",
        :label="label",
        :prepend-icon="icon",
        readonly,
        v-on="on",
        :disabled="disabled",
        :errors="errors",
      )
    v-time-picker(
      v-model="time",
      @input="menu = false",
      :min="min",
      :max="max",
      :disabled="disabled",
      :format="format",
      @change="$emit('change', $event)"
    )
</template>
<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Time'
    },
    icon: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: '24hr'
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      time: this.value
    }
  },
  watch: {
    time: function(n,o) {
      this.$emit('input', this.time)
    }
  }
}
</script>